import { Box } from '@wix/design-system';
import { ReviewsColumnProps } from '../types';
import DefaultReviewComponent from '../DefaultRenderedComponents/Review/PaddedReview';
import { DATA_HOOKS } from '../constants';

const ReviewColumn = ({
  reviews,
  i18nKeys,
  isMobileView,
  replyProps,
  isMyProfile,
  services,
  handleBiGenericClick,
  onEdit,
  userReview,
  startIndex,
  endIndex,
  className,
  reviewConfig: {
    shouldShowDivider,
    reviewClassName,
    ReviewComponent = DefaultReviewComponent,
    ...reviewConfig
  },
}: ReviewsColumnProps) => {
  const slicedReviews = reviews.slice(startIndex, endIndex);

  return (
    <Box className={className} dataHook={DATA_HOOKS.REVIEWS_COLUMN}>
      {slicedReviews.map((review, index) => {
        const showDivider = shouldShowDivider?.(index, slicedReviews.length);

        return (
          <Box key={review.id} display="block" dataHook="padded-review-wrapper">
            <ReviewComponent
              className={reviewClassName}
              review={review}
              services={services}
              isMyProfile={isMyProfile}
              handleBiGenericClick={handleBiGenericClick}
              i18nKeys={i18nKeys}
              isMobileView={isMobileView}
              replyProps={{
                ...replyProps,
                replyAuthorTitle: i18nKeys.replyAuthorTitle,
              }}
              onEdit={onEdit}
              userReview={userReview}
              showDivider={showDivider}
              {...reviewConfig}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ReviewColumn;
